import { IFaireMoney } from '../../indigofair/data/IFaireMoney';
import { IMembership } from '../../indigofair/data/IMembership';
import { IPayment } from '../../indigofair/data/IPayment';
import { InsiderTermsAndConditionsStatus } from '../../indigofair/insider/InsiderTermsAndConditionsStatus';

export namespace IInsiderMembershipInformation {
  export type StateType =
    | 'STATE_UNKNOWN'
    | 'TRIALING'
    | 'ACTIVE'
    | 'CANCELLED'
    | 'UNPAID'
    | 'PAUSED'
    | 'NOT_ELIGIBLE'
    | 'ELIGIBLE'
    | 'AUTO_ENROLLED_TRIAL';

  export enum State {
    STATE_UNKNOWN = 'STATE_UNKNOWN',
    TRIALING = 'TRIALING',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    UNPAID = 'UNPAID',
    PAUSED = 'PAUSED',
    /**
     * Excluded from insider due to experiment
     */
    NOT_ELIGIBLE = 'NOT_ELIGIBLE',
    /**
     * Eligible but have never had insider -- will purchase free trial first
     */
    ELIGIBLE = 'ELIGIBLE',
    AUTO_ENROLLED_TRIAL = 'AUTO_ENROLLED_TRIAL',
  }

  /**
   * Return an instance of IInsiderMembershipInformation with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IInsiderMembershipInformation>
  ): IInsiderMembershipInformation =>
    ({
      threshold_values: {},
      ...(partial ?? {}),
    }) as IInsiderMembershipInformation;
}

export interface IInsiderMembershipInformation {
  state: keyof typeof IInsiderMembershipInformation.State | undefined;
  action_at_period_end: keyof typeof IMembership.ActionAtPeriodEnd | undefined;
  cancel_at_period_end: boolean | undefined;
  pause_at_period_end: boolean | undefined;
  paused_until: number | undefined;
  /**
   * membership cost with possible discounts *
   */
  incoming_membership_cost: IFaireMoney | undefined;
  membership_created_at: number | undefined;
  send_billing_reminders: boolean | undefined;
  current_period_start_at: number | undefined;
  current_period_end_at: number | undefined;
  current_period_payment: IPayment | undefined;
  has_free_import_duties: boolean | undefined;
  has_free_shipping: boolean | undefined;
  membership_token: string | undefined;
  trialing_period_days: number | undefined;
  /**
   * default (standard) monthly membership cost *
   */
  standard_membership_cost: IFaireMoney | undefined;
  terms_acceptance_status:
    | keyof typeof InsiderTermsAndConditionsStatus
    | undefined;
  has_shopify_free_insider_membership: boolean | undefined;
  shopify_free_period_end_at: number | undefined;
  /**
   * @deprecated
   */
  threshold_value: IFaireMoney | undefined;
  threshold_values: Partial<Record<string, IFaireMoney>>;
  annual_standard_membership_cost: IFaireMoney | undefined;
  charge_interval: keyof typeof IMembership.ChargeInterval | undefined;
}
